import { KOALA } from 'HubStyleTokens/colors';
import { default as Image } from '../images/imageUrls';
import { ImageKey } from '../images/ImageKey';
import { isReducedMotionEnabled, isSafariOrIos } from '../utils/deviceUtils';
import { ColorThemeOption } from './ColorLibrary';
import { MessageKey } from './MessageKey';
import { MessageTypes } from './MessageTypes';
import { Data } from '../signup-data/DATA';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
const shouldShowAlternativeContent = isSafariOrIos() || isReducedMotionEnabled();
const LANDING_PAGE = MessageTypes.messageBlobCaption({
  imageUrl: [Image.landingPageHeadshot1x, Image.landingPageHeadshot2x, Image.landingPageHeadshot3x],
  blobBleed: true,
  imageHeight: 400,
  colorThemeOption: ColorThemeOption.OrangeMedium,
  centreMessageOnMobile: true,
  blobBleedConfig: {
    yOffset: -30
  }
});
const BLONDE_SHELLEY = MessageTypes.blobProfile({
  imageUrl: [Image.blondeShelley1x, Image.blondeShelley2x, Image.blondeShelley3x],
  colorThemeOption: ColorThemeOption.YellowLight,
  blobBleed: true,
  imageHeight: 360,
  blobBleedConfig: {
    yOffset: -10
  }
});
const ANNE_HUBSPOT = MessageTypes.blobProfile({
  imageUrl: [Image.anneHubspot1x, Image.anneHubspot2x, Image.anneHubspot3x],
  imageHeight: 340,
  blobBleed: false,
  colorThemeOption: ColorThemeOption.YellowLight
});
const MARGAUX_IMAGE = MessageTypes.messageBlobCaption({
  imageUrl: [Image.crmCentralPlace1x, Image.crmCentralPlace2x, Image.crmCentralPlace3x],
  imageHeight: 330,
  colorThemeOption: ColorThemeOption.OrangeLight,
  captionImage: Image.rever1x,
  captionImageHeight: 34,
  blobBleedConfig: {
    xOffset: -1.5
  },
  blobBleed: false
});
const HUB_INTEREST_MARKETING = MessageTypes.illustratedList({
  illustrationName: 'marketing-free',
  isHTMLMessage: true,
  height: '150px'
});
const HUB_INTEREST_SALES = MessageTypes.illustratedList({
  illustrationName: 'sales-free',
  isHTMLMessage: true,
  height: '150px'
});
const HUB_INTEREST_CUSTOMER_SERVICE = MessageTypes.illustratedList({
  illustrationName: 'service-free',
  isHTMLMessage: true,
  height: '150px'
});
const HUB_INTEREST_CMS = MessageTypes.illustratedList({
  illustrationName: 'website-platform-laptop',
  isHTMLMessage: true,
  height: '150px'
});
const HUB_INTEREST_LANDING_PAGE = MessageTypes.illustratedList({
  illustrationName: 'target',
  height: '150px'
});
const HUB_INTEREST_HIGHLIGHT_CAPTION = MessageTypes.highlightCaption(Object.assign({}, HUB_INTEREST_LANDING_PAGE, {
  // () => null renders an empty component so the right content is empty until a hub interest is selected
  landingPageComponent: () => null,
  dataKey: Data.HubInterest,
  highlightMessageKeys: {
    [HubInterestOption.Sales]: MessageKey.HubInterestSales,
    [HubInterestOption.Marketing]: MessageKey.HubInterestMarketing,
    [HubInterestOption.CustomerService]: MessageKey.HubInterestCustomerService,
    [HubInterestOption.CMS]: MessageKey.HubInterestCms
  }
}));
const PETER_HUBSPOT = MessageTypes.blobProfile({
  imageUrl: [Image.blueGreyBeardGlasses1x, Image.blueGreyBeardGlasses2x, Image.blueGreyBeardGlasses3x],
  colorThemeOption: ColorThemeOption.BlueLight,
  imageHeight: 340,
  blobBleed: true,
  blobBleedConfig: {
    yOffset: -10
  }
});
const SALES_QUOTE = MessageTypes.quote({
  imageUrl: Image.irwinLogo,
  imageHeights: [50, 50],
  altText: 'Irwin'
});
export const MESSAGE = {
  [MessageKey.NoCreditCardNeededMarketing]: LANDING_PAGE,
  [MessageKey.NoCreditCardNeededCrm]: LANDING_PAGE,
  [MessageKey.GenericLandingPage]: LANDING_PAGE,
  [MessageKey.HubspotAcademy]: LANDING_PAGE,
  [MessageKey.GetStartedWithSalesHub]: LANDING_PAGE,
  [MessageKey.GetStartedWithServiceHub]: LANDING_PAGE,
  [MessageKey.BecomeASolutionsProvider]: LANDING_PAGE,
  [MessageKey.SolutionsDirectory]: LANDING_PAGE,
  [MessageKey.GetStartedWithDeveloperAccount]: LANDING_PAGE,
  [MessageKey.HubspotForStartupsLanding]: LANDING_PAGE,
  [MessageKey.HubspotForPartnersLanding]: LANDING_PAGE,
  [MessageKey.TrialSalesEnt]: LANDING_PAGE,
  [MessageKey.TrialSalesPro]: LANDING_PAGE,
  [MessageKey.TrialMarketingEnt]: LANDING_PAGE,
  [MessageKey.TrialMarketingPro]: LANDING_PAGE,
  [MessageKey.TrialServiceEnt]: LANDING_PAGE,
  [MessageKey.TrialServicePro]: LANDING_PAGE,
  [MessageKey.TrialOpsEnt]: LANDING_PAGE,
  [MessageKey.TrialOpsPro]: LANDING_PAGE,
  [MessageKey.TrialCmsEnt]: LANDING_PAGE,
  [MessageKey.TrialCmsPro]: LANDING_PAGE,
  [MessageKey.HubSpotElevate]: LANDING_PAGE,
  [MessageKey.HubSpotStrategicPartner]: LANDING_PAGE,
  [MessageKey.GrowYourNetwork]: LANDING_PAGE,
  [MessageKey.CaptureLeads]: LANDING_PAGE,
  [MessageKey.CMSHub]: shouldShowAlternativeContent ? MessageTypes.messageBlobCaption({
    imageUrl: [Image.cmsFreeMarketplace1x, Image.cmsFreeMarketplace2x, Image.cmsFreeMarketplace3x],
    imageHeight: 230,
    colorThemeOption: ColorThemeOption.OrangeMedium,
    blobBleed: false,
    isCard: true,
    showBorder: true,
    blobBleedConfig: {
      xOffset: -10,
      yOffset: 60
    }
  }) : MessageTypes.animation({
    imageUrl: Image.cmsFreeAnimation,
    renderBlob: true,
    loop: true,
    colorThemeOption: ColorThemeOption.OrangeMedium,
    blobBleedConfig: {
      xOffset: -10,
      yOffset: 60
    }
  }),
  [MessageKey.RedLaughingGlasses]: MessageTypes.blobProfile({
    imageUrl: [Image.redLaughingGlasses1x, Image.redLaughingGlasses2x, Image.redLaughingGlasses3x],
    colorThemeOption: ColorThemeOption.OrangeDark,
    blobBleed: true,
    imageHeight: 340
  }),
  [MessageKey.GirlSmilingPinkJacket]: MessageTypes.blobProfile({
    imageUrl: [Image.girlSmillingPinkJacket1x, Image.girlSmillingPinkJacket2x, Image.girlSmillingPinkJacket3x],
    colorThemeOption: ColorThemeOption.YellowLight,
    blobBleed: true,
    imageHeight: 330
  }),
  [MessageKey.GlassesColourfulScarf]: MessageTypes.blobProfile({
    imageUrl: [Image.glassesColourfulScarf1x, Image.glassesColourfulScarf2x, Image.glassesColourfulScarf3x],
    blobBleed: true,
    imageHeight: 330,
    colorThemeOption: ColorThemeOption.OrangeLight
  }),
  [MessageKey.ShortBlackHairSmiling]: MessageTypes.blobProfile({
    imageUrl: [Image.shortBlackHairSmiling1x, Image.shortBlackHairSmiling2x, Image.shortBlackHairSmiling3x],
    blobBleed: true,
    colorThemeOption: ColorThemeOption.OrangeLight,
    imageHeight: 340
  }),
  [MessageKey.Flywheel]: MessageTypes.imageMessage({
    imageKey: ImageKey.Flywheel,
    altText: 'Flywheel'
  }),
  [MessageKey.SurveyMonkeyQuote]: MessageTypes.quote({
    imageUrl: Image.longSurveyMonkeyLogo,
    imageHeights: [34, 35],
    altText: 'SurveyMonkey'
  }),
  [MessageKey.FreelanceDeveloperQuote]: MessageTypes.quote({
    imageUrl: Image.gonzaloTorrerasLogo,
    imageHeights: [34, 35],
    altText: 'Gonzalo Torreras'
  }),
  [MessageKey.AcademyQuote]: MessageTypes.quote(),
  [MessageKey.AnneHubspot]: ANNE_HUBSPOT,
  [MessageKey.FindYourDreamJob]: ANNE_HUBSPOT,
  [MessageKey.KyleAcademy]: MessageTypes.blobProfile({
    imageUrl: [Image.kyle1x, Image.kyle2x, Image.kyle3x],
    imageHeight: 340,
    blobBleed: true,
    colorThemeOption: ColorThemeOption.BlueLight,
    blobBleedConfig: {
      yOffset: -10
    }
  }),
  [MessageKey.KaraAcademy]: MessageTypes.blobProfile({
    imageUrl: [Image.kara1x, Image.kara2x, Image.kara3x],
    imageHeight: 330,
    blobBleed: true,
    colorThemeOption: ColorThemeOption.YellowLight
  }),
  [MessageKey.BlueGreyBeardGlasses]: PETER_HUBSPOT,
  [MessageKey.SocialProofLogos]: MessageTypes.imagesInGrid({
    imageArray: [{
      image: Image.classpassLogo,
      maxHeights: ['60px, 25px'],
      altText: 'ClassPass'
    }, {
      image: Image.soundcloudLogo,
      maxHeights: ['60px, 50px'],
      altText: 'SoundCloud'
    }, {
      image: Image.g2CrowdLogo,
      maxHeights: ['50px', '50px'],
      altText: 'G2 Crowd'
    }, {
      image: Image.trelloLogo,
      maxHeights: ['45px', '35px'],
      altText: 'Trello'
    }, {
      image: Image.vmwareLogo,
      maxHeights: ['60px', '25px'],
      altText: 'VMWare'
    }, {
      image: Image.longSurveyMonkeyLogo,
      maxHeights: ['30px', '80px'],
      altText: 'SurveyMonkey'
    }],
    bgColor: KOALA
  }),
  [MessageKey.SalesLogos]: MessageTypes.imagesInGrid({
    imageArray: [{
      image: Image.legalZoomLogo,
      maxHeights: ['60px, 25px'],
      altText: 'LegalZoom'
    }, {
      image: Image.vacasaLogo,
      maxHeights: ['60px, 50px'],
      altText: 'Vacasa'
    }, {
      image: Image.motleyFoolLogo,
      maxHeights: ['50px', '50px'],
      altText: 'Motley Fool'
    }, {
      image: Image.casioLogo,
      maxHeights: ['45px', '35px'],
      altText: 'Casio'
    }, {
      image: Image.wistiaLogo,
      maxHeights: ['60px', '25px'],
      altText: 'Wistia'
    }, {
      image: Image.zapierLogo,
      maxHeights: ['30px', '80px'],
      altText: 'Zapier'
    }],
    bgColor: KOALA
  }),
  [MessageKey.ServiceLogos]: MessageTypes.imagesInGrid({
    imageArray: [{
      image: Image.goFundMeLogo,
      maxHeights: ['60px, 25px'],
      altText: 'GoFundMe'
    }, {
      image: Image.legalZoomLogo,
      maxHeights: ['60px, 50px'],
      altText: 'LegalZoom'
    }, {
      image: Image.newcastleUniversityLogo,
      maxHeights: ['50px', '50px'],
      altText: 'Newcastle University'
    }, {
      image: Image.ezCaterLogo,
      maxHeights: ['45px', '35px'],
      altText: 'ezCater'
    }, {
      image: Image.frontifyLogo,
      maxHeights: ['60px', '25px'],
      altText: 'Frontify'
    }, {
      image: Image.oceanSprayLogo,
      maxHeights: ['30px', '80px'],
      altText: 'Ocean Spray'
    }],
    bgColor: KOALA
  }),
  [MessageKey.MarketingIndustries]: MessageTypes.imagesInGrid({
    imageArray: [{
      image: Image.vmwareLogo,
      maxHeights: ['60px', '25px'],
      altText: 'VMWare'
    }, {
      image: Image.loomLogo,
      maxHeights: ['60px', '50px'],
      altText: 'Loom'
    }, {
      image: Image.trelloLogo,
      maxHeights: ['45px', '35px'],
      altText: 'Trello'
    }, {
      image: Image.mondayLogo,
      maxHeights: ['70px', '60px'],
      altText: 'Monday'
    }, {
      image: Image.frontifyLogo,
      maxHeights: ['60px', '50px'],
      altText: 'Frontify'
    }, {
      image: Image.longSurveyMonkeyLogo,
      maxHeights: ['100px', '100px'],
      altText: 'SurveyMonkey'
    }]
  }),
  [MessageKey.PersonWithBox]: MessageTypes.messageBlobCaption({
    imageUrl: [Image.personWithBox1x, Image.personWithBox2x, Image.personWithBox3x],
    imageHeight: 450,
    blobBleed: true,
    colorThemeOption: ColorThemeOption.YellowLight,
    shouldShowDecorativeBlob: true,
    imageWidth: '100%',
    shouldUseConfigOffsetFirefox: true,
    blobBleedConfig: {
      top: 90,
      yOffset: -70
    },
    blobHeight: '120%'
  }),
  [MessageKey.Hands]: MessageTypes.messageBlobCaption({
    imageUrl: [Image.hands1x, Image.hands2x, Image.hands3x],
    imageHeight: 330,
    blobBleed: false,
    colorThemeOption: ColorThemeOption.YellowLight,
    shouldShowDecorativeBlob: true
  }),
  [MessageKey.WhiteHouse]: MessageTypes.messageBlobCaption({
    imageUrl: [Image.whiteHouse1x, Image.whiteHouse2x, Image.whiteHouse3x],
    imageHeight: 340,
    imageWidth: '105%',
    blobBleed: true,
    colorThemeOption: ColorThemeOption.YellowLight,
    blobBleedConfig: {
      top: 42,
      yOffset: -10
    },
    captionImage: Image.rever1x,
    captionImageHeight: 34,
    shouldShowDecorativeBlob: true
  }),
  [MessageKey.CheckYourEmail]: shouldShowAlternativeContent ? MessageTypes.illustration({
    illustrationName: 'email-confirmation',
    colorThemeOption: ColorThemeOption.YellowLight,
    topMargin: '-20'
  }) : MessageTypes.animation({
    imageUrl: Image.emailAnimation,
    topMargin: '-70'
  }),
  [MessageKey.PasswordLock]: shouldShowAlternativeContent ? MessageTypes.illustration({
    illustrationName: 'lock',
    colorThemeOption: ColorThemeOption.YellowLight
  }) : MessageTypes.animation({
    imageUrl: Image.lockScreenAnimation
  }),
  [MessageKey.AcademyHat]: MessageTypes.illustration({
    illustrationName: 'training-academy'
  }),
  [MessageKey.CrmCentralPlace]: MARGAUX_IMAGE,
  [MessageKey.LearnNewSkill]: MARGAUX_IMAGE,
  [MessageKey.HubInterestLandingPage]: HUB_INTEREST_HIGHLIGHT_CAPTION,
  [MessageKey.HubInterestSales]: HUB_INTEREST_SALES,
  [MessageKey.HubInterestMarketing]: HUB_INTEREST_MARKETING,
  [MessageKey.HubInterestCustomerService]: HUB_INTEREST_CUSTOMER_SERVICE,
  [MessageKey.HubInterestCms]: HUB_INTEREST_CMS,
  [MessageKey.SalesQuote]: SALES_QUOTE,
  [MessageKey.ServiceQuote]: MessageTypes.quote({
    imageUrl: Image.katapultLogo,
    imageHeights: [50, 50],
    altText: 'Katapult'
  }),
  [MessageKey.AdritiAcademy]: MessageTypes.blobProfile({
    imageUrl: [Image.adriti1x, Image.adriti2x, Image.adriti3x],
    colorThemeOption: ColorThemeOption.OrangeLight,
    imageHeight: 340,
    blobBleed: true,
    blobBleedConfig: {
      yOffset: -10
    }
  }),
  [MessageKey.WordpressConnect]: MessageTypes.imageMessage({
    imageKey: ImageKey.Wordpress
  }),
  [MessageKey.LongBrownHairRed]: MessageTypes.blobProfile({
    imageUrl: [Image.longBrownHairRed1x, Image.longBrownHairRed2x, Image.longBrownHairRed3x],
    colorThemeOption: ColorThemeOption.OrangeLight,
    blobBleed: true,
    imageHeight: 330
  }),
  [MessageKey.BlondeShelley]: BLONDE_SHELLEY,
  [MessageKey.GetPaidDirectly]: MessageTypes.blobProfile({
    imageUrl: [Image.blondeShelley1x, Image.blondeShelley2x, Image.blondeShelley3x],
    colorThemeOption: ColorThemeOption.OrangeMedium,
    blobBleed: true,
    imageHeight: 360,
    blobBleedConfig: {
      yOffset: -10
    }
  }),
  [MessageKey.GetDiscovered]: BLONDE_SHELLEY,
  [MessageKey.FreeMeetingSchedulingTools]: MessageTypes.imageMessage({
    imageKey: ImageKey.SalesMeetingsCalendar
  }),
  [MessageKey.EliminateScheduling]: MessageTypes.imageMessage({
    imageKey: ImageKey.SalesLeaderCalendar
  }),
  [MessageKey.AutomateYourSalesProcess]: MessageTypes.imageMessage({
    imageKey: ImageKey.SalesLeaderCalendar
  }),
  [MessageKey.KeepAllYourMeetingsInSync]: MessageTypes.imageMessage({
    imageKey: ImageKey.TimeslotCalendar
  }),
  [MessageKey.EmbedOrEmailYourCalendar]: MessageTypes.imageMessage({
    imageKey: ImageKey.SalesMeetingsConfirmation
  }),
  [MessageKey.CMSWebsitePlatform]: MessageTypes.illustration({
    illustrationName: 'add-on-website',
    height: '16rem'
  }),
  [MessageKey.PersonWithBoxNoCaption]: MessageTypes.messageBlobCaption({
    imageUrl: [Image.personWithBox1x, Image.personWithBox2x, Image.personWithBox3x],
    imageHeight: 450,
    blobBleed: true,
    colorThemeOption: ColorThemeOption.YellowLight,
    shouldShowDecorativeBlob: true,
    imageWidth: '100%',
    shouldUseConfigOffsetFirefox: true,
    blobBleedConfig: {
      top: 90,
      yOffset: -70
    },
    blobHeight: '120%'
  }),
  [MessageKey.BusinessBox]: MessageTypes.businessBox()
};
export const getMessage = messageKey => {
  return MESSAGE[messageKey];
};
export const DEFAULT_MESSAGING = {};